/**
 * SuperAdmin oturum doğrulama — yalnızca superadmin akışında kullanılır.
 * Tenant/eczane token akışına dokunmaz.
 */

export type SuperAdminSessionUser = {
  id: number
  username: string
  email: string
  fullName: string
  permissions: string[]
  lastLoginAt?: string | null
}

export type SuperAdminSessionCheck = {
  valid: boolean
  user?: SuperAdminSessionUser
}

export async function fetchSuperAdminSession(): Promise<SuperAdminSessionCheck> {
  try {
    const res = await fetch('/api/opas/superadmin/session', {
      method: 'GET',
      credentials: 'include',
      cache: 'no-store',
    })

    if (!res.ok) return { valid: false }

    const data = await res.json().catch(() => ({}))
    if (!data?.success || !data?.valid || !data?.user) return { valid: false }

    return { valid: true, user: data.user as SuperAdminSessionUser }
  } catch {
    return { valid: false }
  }
}

export async function invalidateSuperAdminClientSession(
  clearLocalUser: () => void,
): Promise<void> {
  await endSuperAdminServerSession(clearLocalUser)
}

/** Giriş ekranı: yalnızca localStorage — sunucu cookie'lerine dokunma (logout yarışını önler). */
export function clearSuperAdminClientLocal(clearLocalUser: () => void): void {
  clearLocalUser()
}

/** Süper admin çıkışı — önce sunucu çerezleri, sonra isteğe bağlı local temizlik. */
export async function endSuperAdminServerSession(clearLocalUser?: () => void): Promise<void> {
  if (clearLocalUser) {
    clearLocalUser()
  } else if (typeof window !== 'undefined') {
    localStorage.removeItem('opas_user')
  }

  try {
    await fetch('/api/opas/superadmin/logout', {
      method: 'POST',
      credentials: 'include',
      cache: 'no-store',
    })
  } catch {
    // best-effort
  }
}

export function mapSessionUserToAuthUser(user: SuperAdminSessionUser) {
  return {
    id: user.id,
    username: user.username,
    email: user.email,
    fullName: user.fullName,
    role: 'superadmin' as const,
    permissions: user.permissions ?? [],
    lastLoginAt: user.lastLoginAt ?? undefined,
  }
}
